export const APP_URL = process.env.REACT_APP_URL || "https://app.runwayhealth.com";
export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const LANDING_PAGE = process.env.REACT_APP_LANDING_PAGE;
export const STRIPE_KEY = process.env.REACT_APP_STRIPE_KEY;
export const ENV = process.env.REACT_APP_ENV;
export const NODE_ENV = process.env.NODE_ENV;
export const WEBSOCKET_URL = process.env.REACT_APP_WEBSOCKET_URL || "ws://localhost:3001";
export const KLAVIYO_API_KEY = process.env.REACT_APP_KLAVIYO_API_KEY || "";
export const KLAVIYO_LIST_ID = process.env.REACT_APP_KLAVIYO_LIST_ID || "";
export const KLAVIYO_PUBLIC_KEY = process.env.REACT_APP_KLAVIYO_PUBLIC_KEY || "";

// routes
export const USER_URL = "user/";
export const AUTH_URL = "/v1/auth/";
export const STRIPE_URL = "stripe/";
export const MD_URL = "md/";
export const BILLING_URL = "/v1/billing";
export const COUPONS_URL = "/coupons";
export const ORDER_URL = "/order";
export const CASE_URL = "/v1/case";
export const PARTNER_URL = "/v1/partner";
export const RECOMMENDATION_URL = "/v1/recommendation";
export const RECOMMENDATION_TIMEOUT_MS = 10000;
export const CONDITION_URL = "/v1/conditions";
export const LAB_EXAM_URL = "/v1/lab-exam";
export const MEDICATIONS_URL = "/v1/medications";
export const ADDRESS_URL = "/v1/address";

// prices
export const VISIT_FEE_STRIPE_PRICE_ID = process.env.REACT_APP_VISIT_FEE_STRIPE_PRICE_ID;
export const VISIT_FEE_STRIPE_PRODUCT_ID = process.env.REACT_APP_VISIT_FEE_STRIPE_PRODUCT_ID;
export const VISIT_FEE_WITHFLEX_PRICE_ID = process.env.REACT_APP_VISIT_FEE_WITHFLEX_PRICE_ID;
export const VISIT_FEE_WITHFLEX_PRODUCT_ID = process.env.REACT_APP_VISIT_FEE_WITHFLEX_PRODUCT_ID;
export const PRIORITY_SHIPPING_ID = process.env.REACT_APP_PRIORITY_SHIPPING_ID;
export const OVERNIGHT_SHIPPING_ID = process.env.REACT_APP_OVERNIGHT_SHIPPING_ID;

// static content
export const CONDITION_TREATMENT_CONTENTS_URL = process.env.REACT_APP_CONDITION_CONTENT;

// payment providers
export const PAYMENT_PROVIDER_STRIPE = "STRIPE";
export const PAYMENT_PROVIDER_WITHFLEX = "WITHFLEX";
